<template>
  <section class="p6 report section">
    <div class="section-content">
      <div class="left">
        <div class="left-main">
          <div class="title">
            {{$t('HomeText.p6_1')}}
          </div>
          <div class="input-wrapper">
            <el-input :placeholder="$t('HomeText.p6_1_2')" v-model="labNo">
              <div slot="append" @click="toReport">{{$t('HomeText.p6_1_3')}} <i class="el-icon-search"></i></div>
            </el-input>
          </div>
        </div>
      </div>
      <!-- <div class="main"></div>-->
      <div class="right">
        <div class="right-main">
          <i class="icon">
            <img src="../../assets/images/home/p6-icon.png" alt=""/>
          </i>
          <div class="name">{{$t('HomeText.p6_2')}}</div>
          <div class="tel">(+852) 3100 0477</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "p6-report",
    data() {
      return {
        labNo: ''
      }
    },
    methods:{
      toReport(){
        console.log('toReport')
        this.$router.push({
          path:'search',
          query:{

          }
        })
      },
    },
  }
</script>

<style>
  .p6.report .el-input__inner {
    background: transparent;
    border-radius: 0;
  }

  .p6.report .el-input-group__append, .el-input-group__prepend {
    border-radius: 0;
    background-color: #fff;
    color: #000;
  }
</style>
<style lang="scss">
  .p6.report {

    .section-content {
      height: 17vw;
      width: 100%;
    }

    .left, .right {
      width: 50%;
    }

    .left {
      padding-right: 4.5vw;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      background: url("../../assets/images/home/p6-left-bg.jpg") no-repeat;
      background-size: 100% 100% ;

      .left-main {
        .title {
          font-size: 2.5vw;
          color: #fff;
          margin-bottom: .75vw;
        }

        .input-wrapper {
          width: 22vw;
          cursor: pointer;
        }
      }
    }

    .right {
      display: flex;
      align-items: center;
      padding-left: 4.5vw;
      background: #24b99f;
      color: #fff;
      background: url("../../assets/images/home/p6-right-bg.jpg") no-repeat;
      background-size: 100% 100% ;

      .right-main {
        position: relative;
        padding-left: 5vw;
        font-weight: bold;

        .icon {
          position: absolute;
          left: 0;
          top: 1.5vw;

          img {
            width: 3.5vw;
          }
        }

        .name {
          font-size: 1.5vw;
        }

        .tel {
          font-size: 2.5vw;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/home/p6-report.vue